import client from '@api/client';

export const createLoginLink = (email, provider) => {
  const payload = {
    redirectUrl: window.location.href,
    refreshUrl: window.location.href,
  };
  if (email) {
    payload.email = email.email;
  }
  if (provider) {
    payload.provider = provider;
  }
  return client.post('/providers/create-login-link', payload);
};

export const updateRewardSelection = (rewardSelection) => {
  return client.post('/providers/update-reward-selection', {
    rewardSelection: rewardSelection,
  });
};
